export const fromNumberInitializationStatus = {
  idle: 'idle',
  loading: 'loading',
  resolved: 'resolved',
  missing: 'missing',
} as const;

export type FromNumberInitializationStatus =
  (typeof fromNumberInitializationStatus)[keyof typeof fromNumberInitializationStatus];
